import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f21e381"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b bg-white" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-append input-group-append-ico" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-white shadow shadow-sm frmsearchForm-search",
    type: "submit",
    name: "search",
    "data-url": "/search?phrase=placeholder",
    "data-designer": "hdr-srch-btn"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search d-sm-none" }),
    /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-inline" }, "Hľadať")
  ])
], -1))
const _hoisted_6 = {
  class: "twitter-typeahead w-100 position-static",
  style: {"position":"relative","display":"inline-block"}
}
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", {
  "aria-hidden": "true",
  style: {"position":"absolute","visibility":"hidden","white-space":"pre","font-family":"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,","font-size":"15px","font-style":"normal","font-variant":"normal","font-weight":"400","word-spacing":"0px","letter-spacing":"0px","text-indent":"0px","text-rendering":"auto","text-transform":"none"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchDropdown = _resolveComponent("SearchDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("link", {
      rel: "stylesheet",
      href: _ctx.criticalCss
    }, null, 8, _hoisted_2),
    _createElementVNode("link", {
      rel: "stylesheet",
      href: _ctx.afterCss
    }, null, 8, _hoisted_3),
    _createElementVNode("link", {
      rel: "stylesheet",
      href: _ctx.appCss
    }, null, 8, _hoisted_4),
    _createElementVNode("div", {
      class: _normalizeClass(["foxigy-plugin input-group frmsearchForm-wrap", { focus: _ctx.inputFocused }]),
      ref: "mainElement",
      role: "search",
      "data-designer": "hdr-srch"
    }, [
      (_ctx.isMainElementVisible)
        ? (_openBlock(), _createBlock(_component_SearchDropdown, {
            key: 0,
            query: _ctx.searchModuleStore.getQuery,
            parent: _ctx.mainElement
          }, null, 8, ["query", "parent"]))
        : _createCommentVNode("", true),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("input", {
          class: "form-control pr-5 frmsearchForm-phrase tt-input",
          type: "search",
          name: "phrase",
          placeholder: "Hľadať",
          "aria-label": "Hľadať",
          "data-products-header": "Produkty",
          "data-categories-header": "Kategórie",
          "data-articles-header": "Recenzie",
          "data-products-url": "/search/suggest?type=products&phrase=%QUERY",
          "data-categories-url": "/search/suggest?type=categories&phrase=%QUERY",
          "data-articles-url": "/search/suggest?type=articles&phrase=%QUERY",
          "data-no_item": "Žiadna položka",
          "data-loading": "Načítavanie",
          "data-show_all": "Zobraziť všetko",
          autocomplete: "off",
          spellcheck: "false",
          dir: "auto",
          style: {"position":"relative","vertical-align":"top"},
          onFocusin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchModuleStore.setResultsVisibility(true))),
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputFocused = true)),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputFocused = false)),
          value: _ctx.searchModuleStore.getQuery,
          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setQuery && _ctx.setQuery(...args)))
        }, null, 40, _hoisted_7),
        _hoisted_8
      ])
    ], 2)
  ]))
}